// storybook-check-ignore
import React from 'react';

import { motion } from 'framer-motion';

import type { MegaNavItem, MenuLink } from '../../types';
import { MenuLinkItem } from '../components/MenuLinkItem';
import { MobileMegaNavButton } from './MobileMegaNavButton';

interface MobileMenuListProps {
  megaNavData?: MegaNavItem[];
  menuPanelNavLinks: MenuLink[];
  mainNavLinks: MenuLink[];
  slug: string;
  tabletDisplay: string;
  navList: any;
  onSubMenuOpen: (itemName: string) => void;
}

const mainMenuVariants = {
  hidden: {
    x: '-100%',
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
    },
  },
  visible: {
    x: 0,
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
    },
  },
};

export const MobileMenuList: React.FC<MobileMenuListProps> = ({
  megaNavData,
  menuPanelNavLinks,
  mainNavLinks,
  slug,
  tabletDisplay,
  navList,
  onSubMenuOpen,
}) => {
  if (megaNavData) {
    return (
      <motion.div initial="visible" animate="visible" exit="hidden" variants={mainMenuVariants}>
        {megaNavData.map((item, idx) => (
          <MobileMegaNavButton
            key={`mega-${idx}`}
            itemName={item.name}
            onClick={() => onSubMenuOpen(item.name)}
          />
        ))}
        {menuPanelNavLinks?.map((link, idx) => (
          <MenuLinkItem
            key={`panel-${idx}`}
            href={link.href}
            name={link.name}
            analyticsName={`cosmos-landing-page-v2-menu-link-${link.name}`}
            isActive={slug === link.href}
            variants={navList}
          />
        ))}
      </motion.div>
    );
  }

  return (
    <>
      {mainNavLinks.map((nav, idx) => (
        <MenuLinkItem
          key={`main-${idx}`}
          href={nav.href}
          name={nav.name}
          analyticsName={`cosmos-landing-page-v2-nav-link-${nav.name}`}
          isActive={slug === nav.href}
          showOnTablet={true}
          tabletDisplay={tabletDisplay}
        />
      ))}
      {menuPanelNavLinks?.map((link, idx) => (
        <MenuLinkItem
          key={`panel-${idx}`}
          href={link.href}
          name={link.name}
          analyticsName={`cosmos-landing-page-v2-menu-link-${link.name}`}
          isActive={slug === link.href}
          variants={navList}
        />
      ))}
    </>
  );
};
